import { defaultClient } from '@mint-sdk/api-core';
import { z } from 'zod';

import { StartPushTrackerMappingsRequestSchema } from '../shared/schemas/pushTrackerMappings.js';

export type { StartPushTrackerMappingsRequest } from '../shared/schemas/pushTrackerMappings.js';

export const startPush = defaultClient.mutation({
  url: 'omni-trafficking/v1/tracker-mappings/push/' as const,
  method: 'POST',
  responseSchema: z.object({}),
  processResponse(data) {
    return data;
  },
  requestSchema: StartPushTrackerMappingsRequestSchema,
});
